import * as req from 'api/actions';
import * as c from './constants';

export const getCounts = (payload = {}, callback) =>
  req.item(
    c.GET_COUNTS,
    '/api/v1/administrators/dashboard/statistics',
    callback,
    payload
  );

export const getCountsSmartCity = (payload = {}, callback) =>
  req.item(
    c.GET_COUNTS_SMART_CITY,
    '/api/v1/administrators/dashboard/statistics/modules',
    callback,
    payload
  );

export const getENewsCounts = (payload = {}, callback) =>
  req.item(
    c.GET_ENEWS_COUNTS,
    '/api/v1/administrators/news_dashboard/statistics',
    callback,
    payload
  );

export const getCollections = (payload = {}, callback) =>
  req.item(
    c.GET_COLLECTION,
    '/api/v1/administrators/dashboard/collection_graph',
    callback,
    payload
  );

export const getDatedCounts = (payload, callback) =>
  req.list(
    c.GET_DATED_COUNTS,
    '/api/v1/administrators/dashboard/graph',
    payload,
    callback
  );

export const getTransactionList = (
  payload = { module_type: 'CDL' },
  callback
) =>
  req.list(
    c.GET_COUNTS,
    '/api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const getYearList = (
  payload,
  callback
) =>
  req.list(
    c.GET_YEAR_LIST,
    '/api/v1/administrators/dashboard/collection_graph_year',
    payload,
    callback
  );
